// @ts-nocheck
import useScript from "@store/Framework/Common/Hooks/useScript";
import React, { createContext, useContext } from "react";

export interface HubspotContextProps {
    readonly loaded: boolean; // Is Hubspot script loaded
    readonly error: boolean; // Is Hubspot failed to loaded
}

export const HubspotContext = createContext<HubspotContextProps>({
    loaded: false,
    error: false,
});

export const useHubspotContext = () => useContext(HubspotContext);

interface HubspotProviderProps {
    scriptSource: string;
    readonly async?: boolean;
    readonly addToHead?: boolean;
    readonly children: React.ReactNode;
}

const HubspotProvider = ({ scriptSource, async, addToHead, children }: HubspotProviderProps) => {
    // Attach hubspot script to the document
    const [loaded, error] = useScript(scriptSource, async, addToHead);

    return <HubspotContext.Provider value={{ loaded, error }}>{children}</HubspotContext.Provider>;
};

export default HubspotProvider;
